@if (visible$ | async) {
<div class="product-id">
  <span class="product-id-label">{{ 'product.sku.label' | translate }}</span>
  <span itemprop="sku">{{ sku$ | async }}</span>
</div>
}
